__turbopack_context__.v({
  "magnify": "index-module__3uGijG__magnify",
});
